import { forwardRef, PropsWithChildren } from 'react'
import { IconButtonLinkProps } from './Types'
import { useHover } from '@react-aria/interactions'
import { useObjectRef } from 'utils/useObjectRef'
import { mergeProps } from '@react-aria/utils'
import useResponsiveDesign from 'hooks/useResponsiveDesign'
import { ButtonLink } from 'blaze-ui/Button/ButtonLink'

const IconButtonLink = forwardRef<HTMLAnchorElement, PropsWithChildren<IconButtonLinkProps>>(
  ({ icon, children, variant = 'primary', size = 'md', ...props }, fRef) => {
    const ref = useObjectRef<HTMLAnchorElement>(fRef)
    const { isMobile } = useResponsiveDesign()
    const { isDisabled, onHoverStart, onHoverEnd } = props
    const { hoverProps } = useHover({
      isDisabled,
      onHoverStart,
      onHoverEnd,
    })

    return (
      <ButtonLink
        aria-label={props.title}
        {...mergeProps(props, hoverProps)}
        variant={variant}
        size={size}
        ref={ref}
        frontIcon={children ? undefined : icon}
        preventFocusOnPress={isMobile || props.preventFocusOnPress}
      >
        {icon ? null : children}
      </ButtonLink>
    )
  },
)

export { IconButtonLink }
